import React, { useState } from "react";
import FrontLayout from "../../../components/layout-new-theme/FrontLayout";
import CustomerLogin from "../../../components/auth/CustomerLogin";

const CustomerLoginPage = () => {
  const [isRegister, setIsRegister] = useState(false);
  return (
    <FrontLayout>
      <div className="tw:mt-[122px] tw:h-[calc(100vh-122px)] tw:flex tw:flex-col tw:justify-between">
        <CustomerLogin
          // login={() => null}
          // loginWithGoogle={() => null}
          isAuthenticated={false}
          useModal={false}
          isRegister={isRegister}
          setIsRegister={setIsRegister}
        />
      </div>
    </FrontLayout>
  );
};

export default CustomerLoginPage;
